const SOUND_PREFERENCE_KEY = "carmel.notificationSound";

export function isNotificationSoundEnabled(): boolean {
  if (typeof window === "undefined") return true;
  return window.localStorage.getItem(SOUND_PREFERENCE_KEY) !== "false";
}

export function setNotificationSoundEnabled(enabled: boolean): void {
  window.localStorage.setItem(SOUND_PREFERENCE_KEY, String(enabled));
}

export async function playNotificationAlert(): Promise<void> {
  await playSound("/notification-alert.mp3");
}

export async function playToastTone(type: "success" | "error"): Promise<void> {
  await playSound(type === "success" ? "/notification-alert.mp3" : "/toast-error.mp3");
}

async function playSound(source: string): Promise<void> {
  if (!isNotificationSoundEnabled() || typeof window === "undefined") return;

  try {
    const audio = new Audio(source);
    audio.volume = 0.35;
    await audio.play();
  } catch {
    // Browsers may block sound until the user has interacted with the page.
  }
}
